<template>
  <div class="sign">
    <div class="sign-search">
      <div class="btn-box">
        <van-field
          border
          clickable
          :readonly="isReadonly"
          size="small"
          placeholder="请选择部门"
          @click="showPicker = true"
          @focus="isReadonly = true"
          @blur="isReadonly = false"
          v-model="search.department"
          is-link
          arrow-direction="down"
          clearable
          clear-trigger="always"
        />
        <van-field
          size="small"
          v-model="search.sku"
          placeholder="SKU"
          right-icon="scan"
          @click-right-icon="scanSku"
          @keyup.13="getList('search')"
         @input="getList('search')"
        />
      </div>
      <div class="toSearch-box">
        <button class="sign-toSearch" @click="getList('search')">查询</button>
      </div>
    </div>

    <div class="sign-item">
      <template v-if="startSearch">
        <van-loading size="24px" vertical>加载中...</van-loading>
      </template>
      <template v-else>
        <template v-if="list.length">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            :immediate-check="false"
            ref="vList"
            @load="onLoad"
          >
            <ul>
              <li
                v-for="(item, index) in list"
                :key="index"
                style="position: relative"
              >
                <van-swipe-cell>
                  <div style="display: flex;flex-direction: column;">
                    <div class="swipe-div" @click="toSignInDetail(item)">
                      <div class="sign-list" >
                        <p>原SKU：{{ item.originalSKU }}</p>
                      </div>
                      <div class="sign-list" >
                        <p>新SKU：{{ item.newSKU }}</p>
                      </div>
                      <div class="sign-list">
                        <p>部门：{{ item.department }}</p>
                        <p>数量{{ item.quantity }}</p>
                      </div>
                    </div>
                  </div>
                  <template #right>
                    <van-button
                      square
                      type="success"
                      style="height: 100%; top: -1px;color:#fff;"
                      text="打印"
                      :style="{'background-color':'#35495e','border-color':'#35495e'}"
                      @click="printSkuFun(item.newSKU,item.newProductNameCN,item.quantity,item.warehouseID)"
                    />
                  </template>
                </van-swipe-cell>
              </li>
            </ul>
          </van-list>
        </template>
        <template v-else>
          <van-empty image="search" description="暂无数据" />
        </template>
      </template>
    </div>

    <van-popup
      v-model="showPicker"
      round
      position="bottom"
      @close="pickerClose"
    >
      <van-picker
        show-toolbar
        cancel-button-text="关闭"
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        @change="onItemChange"
        ref="departmentPicker"
        :item-height="30"
        :visible-item-count="5"
      />
    </van-popup>

	<van-action-sheet
			v-model="showActionSheetForPrint"
			:actions="actionsForPrint"
			closeable
			:lazy-render="false"
			cancel-text="取消"
			description="请先选择打印机"
			@select="actionSheetSelectForPrint"
		/>

    <van-dialog
      v-model="printSkuShow"
      :title="`打印SKU条码`"
      show-cancel-button
      confirmButtonText="提交"
      cancelButtonText="取消"
      @confirm="printSkuSubmit"
    >
    <div style="padding: 2% 5%">
       {{this.printSku}}
     </div>
     <div style="padding: 2% 5%">
       {{this.printSkuName}}
     </div>
      <div style="padding: 5% 5%">
        <van-field v-model="printSkuNum" type="digit" label="数量:" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Icon, Badge, Picker, Popup, Field, Toast, Empty, List, Loading, Checkbox, Tab, Tabs, ActionSheet,SwipeCell,Button ,Col, Row, Dialog } from 'vant';
import { getDepartmentList } from "@/api/mobile/signIn_api";
import { getLabelChangeListData,ChangelabelPrintSku } from "@/api/mobile/changelabel_api";
import { GetPrinterByUser,AddUserPrinter } from '@/api/mobile/common_api';
import { mapState } from "vuex";
import util from "util/date";
import { debounce } from "util/util";
import { mixins } from "../mobileMixins";

export default {
  data() {
    return {
      showPicker: false,
      value: "",
      columns: [],
      search: {
        page: 1,
        pageSize: 15,
        department: "",
        sku: "",
        warehouseId: "",
      },
      list: [],
      departmentList: [],
      loading: false,
      finished: false,
      startSearch: false,
      isReadonly: false,
      printSkuShow:false,
      printSku:"",
      printSkuName:"",
      printSkuNum:0,
      selectwarehouseID:0,
      printSuccess: false,
      showActionSheetForPrint:false,
			actionsForPrint: [],
      isSetPrinter: false,
			printSuccess: false,
			savePrintArr: []
    };
  },

  components: {
		[Icon.name]: Icon,
		[Badge.name]: Badge,
		[Picker.name]: Picker,
		[Popup.name]: Popup,
		[Toast.name]: Toast,
		[List.name]: List,
		[Empty.name]: Empty,
		[Loading.name]: Loading,
		[Checkbox.name]: Checkbox,
		[Tab.name]: Tab,
		[Tabs.name]: Tabs,
		[Col.name]: Col,
		[Row.name]: Row,
		[ActionSheet.name]: ActionSheet,
		[SwipeCell.name]: SwipeCell,
		[Button.name]: Button,
		[Dialog.Component.name]: Dialog.Component,
		[Field.name]: Field,
   	// [Tab.name]: Tag,
  },

  mixins: [mixins],

  created() {
    this.init();
  },

  computed: {
    ...mapState({ warehouse: (state) => state.common.warehouse }),
  },

  methods: {
    init() {
      const _warehouse = window.localStorage.warehouse
        ? JSON.parse(window.localStorage.warehouse)
        : this.warehouse;
      this.$set(this.search, "warehouseId", _warehouse.warehouseId);

      this.getDepartment();
    },
    getDepartment() {
      const user = window.localStorage.user
        ? JSON.parse(window.localStorage.user)
        : null;
      const data = {
        orgID: user.organizationId || "",
      };

      getDepartmentList(data).then((res) => {
        if (res.status === 200) {
          const { response } = res;

          this.departmentList = response;

          let arr = [];
          response.forEach((item) => {
            arr.push(item.departmentName);
          });
          this.columns = arr;
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    pickerClose() {
      this.$refs.departmentPicker.confirm();
    },
    onConfirm(val) {
      this.$set(this.search, "department", val);
      this.showPicker = false;
    },
    onItemChange(e, value, index) {
      function fn() {
        const that = this;
        this.$set(this.search, "department", value);
        that.showPicker = false;
      }
      debounce(fn.apply(this), 300);
    },
    scanSku() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.$set(that.search, "sku", a.resultStr);
          that.getList('search')
        },
      });
    },
    getList(type) {
      if (type === "search") {
        this.list = [];
        this.finished = false;
        this.search.page = 1;
      }

      const data = {
        ...this.search,
      };

      if (this.search.page === 1) {
        this.startSearch = true;
      }
     
      const _warehouse = JSON.parse(window.localStorage.warehouse)

     this.search.warehouseId=_warehouse.warehouseId
     
      getLabelChangeListData(data).then((res) => {
        this.loading = false;
        this.startSearch = false;
        if (res.status === 200) {
          const { pageData, pageCount, pageIndex } = res.response;

          if (!pageData.length) Toast("暂无匹配数据");

          try {
            pageData.forEach((row) => {
              row.estimatedDate = util.formatDate.format(
                new Date(row.estimatedDate),
                "yyyy-MM-dd"
              );
            });
          } catch {}

          if (pageCount === pageIndex) {
            this.finished = true;
          }

          this.list.push(...pageData);
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    // 查询用户是否设置打印机
		toGetPrinterByUser(warehouseID){
			const data = {
				moduleType: 3, // 换标
				wareId: warehouseID
			}
			this.isSetPrinter = false
			this.actionsForPrint = []
      console.log('显示打印机');
			GetPrinterByUser(data).then(res=>{
				const {status,response,msg} = res
				if(status === 200 && response.length){
					this.showActionSheetForPrint = true
					response.forEach((item,i)=>{
						this.actionsForPrint.push({name:item.printerName,id:item.printerInfoID})
					})
				}else if(status === -100){
					Toast(msg)
				}
				if(status === 200 && response === 0){
					this.isSetPrinter = true
				}
			})
        console.log('显示打印机'+this.isSetPrinter);
		},
actionSheetSelectForPrint(act,i){
			this.toAddUserPrinter(act.id)
			this.showActionSheetForPrint = false
		},
    // 新增打印机
		toAddUserPrinter(id){
			const data = {
				moduleType: 3, // 打包 1 ，备柜 2 换标
				printerInfoID: id
			}
			AddUserPrinter(data).then(res=>{
				const {status,response,msg} = res
				if(status === 200){
					this.isSetPrinter = true
					Toast.success(msg || '添加打印机成功')
				}else{
					Toast(msg)
				}
			})
		},
    printSkuFun(newSKU,newProductNameCN,printnum,warehouseID){
   console.log('点击打印');
      this.printSku=newSKU;
      this.printSkuName=newProductNameCN;
      this.printSkuNum=printnum;
      this.selectwarehouseID=warehouseID;

       this.toGetPrinterByUser(warehouseID);
       this.printSkuShow = true;
    },

     printSkuSubmit() {
      const that = this;
   
      if(Number(this.printSkuNum)<=0){
        Toast('请输入大于0的数值')
        return
      }

			if(!this.isSetPrinter) {
				Toast('请选择打印机')
				this.toGetPrinterByUser(this.selectwarehouseID)
				return
			}
			this.printSuccess = false
      var data=[];
      data.push({sku:this.printSku,boxCount:Number(this.printSkuNum),productNameCN:this.printSkuName,warehouseId:this.selectwarehouseID});
      ChangelabelPrintSku(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          this.jsonpPrint(res.response);
          
          this.getList("search");
        } else {
          Toast.fail(res.msg);
        }
      });

      
    },
    toSignInDetail(item) {
      console.log(item);
      const { labelChangeID } = item;
      this.$router.push({
        path: "/mobile/ChangelabelDetail",
        query: { labelChangeID },
      });
      console.log("传参：" + labelChangeID);
    },
    onLoad() {
      this.search.page++;

      this.getList();
    },

    jsonpPrint(url){
			Toast.loading({
				message: '打印中...',
				forbidClick: true,
				loadingType: 'spinner',
				duration: 0
			});
     
   //  console.log('打印机地址是:'+url);
    
			this.$http.jsonp(url).then(res => {
				console.log('success',res.body.s);    //请求成功
				Toast.clear();
				Toast.success('打印成功');
				// 更新状态
				this.printSuccess = true
				
			}).catch(err => {
        	Toast.fail('打印失败');
				console.log('err',err );  //请求失败
				Toast.clear()
				if(err.status === 0){
					// 更新状态    打印机有时会跑到err事件里,暂时这样处理
					this.printSuccess = true;
          Toast.success('打印成功');
          
				}else{
					Toast.fail('打印失败')
				}
			})
		},
   
  },

  watch: {
    $route: async function (newValue, from) {
      this.$nextTick(() => {
        if (newValue.path === "/mobile/mobileMenu") {
          this.list = [];
          this.$set(this.search, "page", 1);
          this.$set(this.search, "pageSize", 10);
          this.$set(this.search, "department", "");

          this.$set(this.search, "sku", "");
        }
        if (newValue.path === "/mobile/signIn") {
          this.$set(this.search, "relationNumber", "");
          if (this.search.department || this.search.sku) {
            this.getList("search");
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../style/mobile_common.less";
::v-deep .van-cell {
  border: 1px solid #adadad;
  margin-bottom: 7px;
  padding: 5px 10px;
}
.sign {
  background-color: #fbf9fe;
}
.sign-search {
  box-sizing: border-box;
  width: 100%;
  padding: 10px 10px 3px 10px;
  display: flex;
}
.sign-search .btn-box {
  flex: 0.6;
}
.sign-search .toSearch-box {
  flex: 0.4;
  margin-left: 3%;
  min-height: 120px;
}
.sign-toSearch {
  width: 100%;
  height: 94%;
  min-height: 120px;
  background: linear-gradient(to right, #1d62f0 0%, #19d4fd 100%);
  border-radius: 5px;
  border: 0;
  color: #fff;
  font-size: 20px;
}
.toSearch-box {
  vertical-align: top;
}
.sign-item {
  border-top: 1px solid #ccc;
}

.sign-item li {
  border-bottom: 1px solid #ccc;
  background-color: #fbf9fe;
 // padding: 3px 10px;
  font-size: 12px;
}
.sign-list {
  display: flex;
  p {
    flex: 1;
    word-break: break-all;
    margin: 5px 20px;
  }
}


.custom-image .van-empty__image {
  width: 90px;
  height: 90px;
}
.sign-search {
    justify-content: center;
    padding: 20px 20px 15px 20px;
}

.sign-search .toSearch-box {
	flex: 0.4;
	margin-left: 3%;
	min-height: 94px;
}

.sign-search .btn-box {
	flex: 0.8;
}

::v-deep .van-cell {
    padding: 7px 16px;
}

.sign-toSearch {
	width: 100%;
    height: 92%;
    min-height: 87px;
	border-radius: 5px;
	border: 0;
	color: #fff;
	font-size: 20px;
}

::v-deep .van-tabs__nav--card {
	margin: 0;
	border: 0;
}

.sign-item .bale-container {
	margin-bottom: 75px;
}

.sign-item .bale-container li {
	display: flex;
	height: 40px;
	line-height: 40px;
	& > div {
		flex: 1;
		text-align: center;
	}
}

.sign-item .bale-container li {
	padding: 0;
	height: 46px;
	line-height: 40px;
}

.sign-item .bale-container .swipe-div{
	display: flex;
	padding: 5px;
	align-items: center;
	flex: 1;
	& > div{
		flex: 1;
	}
}

.noSend-list-left{
    border-top: 1px solid #908d8d;
    border-bottom: 1px solid #908d8d;
	height: 40px;
    line-height: 40px;
	text-align:left;  
	padding: 8px 0 0 32px;
	background-color: #fff;
}
.noSend-list-right{
    border-top: 1px solid #908d8d;
    border-bottom: 1px solid #908d8d;
	height: 40px;
    line-height: 40px;
	background-color: #35495e;color:#fff;
}

.check-box{
	flex: .2;
    display: flex;
    justify-content: center;
}
</style>